module.exports = __webpack_public_path__ + "img/personal-center.f74c32d3.svg";